import { render, staticRenderFns } from "./JudgingModes.vue?vue&type=template&id=5482fa65&"
import script from "./JudgingModes.vue?vue&type=script&lang=js&"
export * from "./JudgingModes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports